import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import Home from './components/Home';
import Employees from './components/employees/Employees';
import RegisterTag from './components/registerTag/RegisterTag';
import Items from './components/items/Items';
import WareHouse from './components/wareHouse/WareHouse';
import Reports from './components/reports/Reports';
import ScanButton from './components/ScanButton';

function App() {
  const [permissions, setPermissions] = useState([]);

  // Check the permissions stored in localStorage when the component mounts
  useEffect(() => {
    const storedPermissions = localStorage.getItem('permissions');
    if (storedPermissions && storedPermissions !== 'undefined') {
      try {
        setPermissions(JSON.parse(storedPermissions));
      } catch (error) {
        console.error("Error parsing permissions from localStorage:", error);
        setPermissions([]);
      }
    }
  }, []);

  // Function to handle permission-based access control
  const ProtectedRoute = ({ children, requiredPermissions }) => {
    if (permissions.length === 0) {
      return <Navigate to="/" />; // Redirect to login if no permissions are found
    }
    if (permissions.includes('admin')) {
      return children; // Admin has access to all routes
    }
    if (!requiredPermissions.some(permission => permissions.includes(permission))) {
      return <Navigate to="/dashboard" />; // Redirect to default route if the user doesn't have required permissions
    }
    return children;
  };

  return (
    <BrowserRouter>
      <Routes>
        {/* Login Route */}
        <Route path="/" element={<LoginPage />} />

        {/* Dashboard Route - Protected */}
        <Route path="/dashboard" element={
          permissions.length > 0 ? <DashboardPage /> : <Navigate to="/dashboard" />
        }>
          {/* Default Route */}
          <Route index element={<Home />} />

          {/* Nested Routes */}
          <Route
            path="employees"
            element={
              <ProtectedRoute requiredPermissions={['employees']}>
                <Employees />
              </ProtectedRoute>
            }
          />
          <Route
            path="items"
            element={
              <ProtectedRoute requiredPermissions={['items']}>
                <Items />
              </ProtectedRoute>
            }
          />
          {/* <Route
            path="registertag"
            element={
              <ProtectedRoute requiredPermissions={['registertag']}>
                <RegisterTag />
              </ProtectedRoute>
            }
          /> */}
          <Route
            path="warehouse"
            element={
              <ProtectedRoute requiredPermissions={['warehouse']}>
                <WareHouse />
              </ProtectedRoute>
            }
          />
          <Route
            path="reports"
            element={
              <ProtectedRoute requiredPermissions={['reports']}>
                <Reports />
              </ProtectedRoute>
            }
          />
          <Route
            path="scan"
            element={
              <ProtectedRoute requiredPermissions={['scan']}>
                <ScanButton />
              </ProtectedRoute>
            }
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
